import React, { useState } from "react";
import { FilePdfOutlined, LoadingOutlined } from "@ant-design/icons";
import { exportItemsToPDF } from "../../utils/exportPdf";

const ExportPdfButton: React.FC = () => {
  const [isExporting, setIsExporting] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleExport = async () => {
    setIsExporting(true);
    setProgress(0);
    try {
      await exportItemsToPDF((p) => setProgress(p));
    } catch (error) {
      console.error("Export PDF failed:", error);
      alert("Failed to export PDF. Please try again.");
    } finally {
      setIsExporting(false);
      setProgress(0);
    }
  };

  return (
    <button
      type="button"
      className="btn d-flex align-items-center gap-0 gap-md-2 export-pdf-btn"
      onClick={handleExport}
      disabled={isExporting}
      title="Export all items to PDF"
      style={{
        borderRadius: "50px",
        padding: "7px 16px",
        fontSize: "14px",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#198754",
        borderColor: "#198754",
        color: "#ffffff",
        borderStyle: "solid",
        borderWidth: "1.5px",
        fontWeight: 600,
        boxShadow: "0 2px 6px rgba(25, 135, 84, 0.25)",
        transition: "all 0.2s ease",
        lineHeight: 1.25,
      }}
    >
      {isExporting && (
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: `${progress}%`,
            backgroundColor: "rgba(255, 255, 255, 0.25)",
            transition: "width 0.2s ease",
            zIndex: 0,
          }}
        />
      )}
      <span
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        {isExporting ? (
          <>
            <LoadingOutlined style={{ fontSize: "15px" }} spin />
            <span className="d-none d-md-inline">Exporting... {progress}%</span>
            <span className="d-inline d-md-none" style={{ marginLeft: "4px" }}>{progress}%</span>
          </>
        ) : (
          <>
            <FilePdfOutlined style={{ fontSize: "15px" }} />
            <span className="d-none d-md-inline">Export</span>
          </>
        )}
      </span>
    </button>
  );
};

export default ExportPdfButton;
